import React, { useState } from "react";
import styled from "styled-components";
import { Modal } from "antd";
import { PrimaryButtonComponent } from "../commonStyles";
import PropTypes from "prop-types";
import { GeneralButton } from "../Commons/commonComponents";
import { CustomCheckbox, DisplayFlex } from "../../CommonComponents/commonStyles";

const StyledErrorPopup = styled(Modal)`
  .ant-modal-footer {
    display: flex;
    justify-content: center;
    text-align: center;
    border-top: none;
    padding: 0;
  }
  .ant-modal-body {
    padding: 0;
    .ant-table-wrapper {
      border-top: 1px solid #b6bdbd;
    }
  }
  .ant-modal-content {
    border-radius: 0px;
    padding: 30px 100px;
    @media only screen and (max-width: 576px) {
      padding: 30px 20px;
    }
    @media only screen and (max-width: 991px) {
      display: flex;
      flex-direction: column;
    }
  }
  @media only screen and (max-width: 991px) {
    width: 98% !important;
    height: 97vh;
    padding: 0;
  }
`;

const PopupHeading = styled.h4`
  font-family: ${(props) => props.theme.fontFamily.berkeleyStd};
  font-size: ${(props) => props.theme.fontSize.h5};
  font-weight: ${(props) => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${(props) => props.theme.fontStretch.normal};
  line-height: ${(props) => props.theme.lineHeight.h5};
  letter-spacing: ${(props) => props.theme.letterSpacing.normal};
  color: ${(props) => props.theme.fontColors.headingColor};
  text-align: center;
  @media only screen and (min-width: 992px) {
    font-size: ${(props) => props.theme.fontSize.h4};
    line-height: ${(props) => props.theme.lineHeight.h4};
  }
`;

const PopupSecondaryLink = styled.a`
  font-family: ${(props) => props.theme.fontFamily.helveticaNeue};
  font-size: ${(props) => props.theme.fontSize.primary};
  font-weight: ${(props) => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${(props) => props.theme.fontStretch.normal};
  line-height: ${(props) => props.theme.lineHeight.primary};
  letter-spacing: ${(props) => props.theme.letterSpacing.normal};
  color: ${(props) => props.theme.fontColors.primary};
  text-decoration: underline;
  &:hover,
  :focus {
    color: ${(props) => props.theme.fontColors.primary};
  }
  @media (min-width: 320px) and (max-width: 768px) {
    font-size: ${(props) => props.theme.fontSize.secondary} !important;
  }
`;

const ContentContainer = styled.div`
  text-align: center;
`;

const ButtonContainer = styled.div`
  text-align: center;
  min-width: 150px;
  button {
    margin-bottom: 15px;
  }
  a {
    letter-spacing: ${(props) => props.theme.letterSpacing.zero};
  }
`;

export default function ErrorPopup({
  title,
  show = false,
  closable = true,
  className='',
  primaryCta,
  onPrimaryCancel = false,
  availableBalance,
  primaryCtaLabel = "Ok",
  secondaryCta,
  secondaryCtaLabel = "Cancel",
  children,
  afterClose = ()=>{}
}) {
  
  const [checkedBal,setCheckedBal] = useState(false);
 
    const enbleOKButton =(e) =>{
      setCheckedBal(!checkedBal)
  }

  return (
    <StyledErrorPopup
      closable={closable}
      className={className}
      centered
      onCancel={secondaryCta ? secondaryCta : primaryCta}
      visible={show}
      width="580px"
      afterClose={afterClose}
      footer={
        <ButtonContainer>
          {primaryCta && (
            <GeneralButton
              id="btnContinue"
              type="primary"
              onClick={primaryCta}
              type="functional"
              text={primaryCtaLabel}
              width="100%"
              mobWidth="100%"
              disabled={!checkedBal && onPrimaryCancel &&availableBalance}
            />
          )}
          {secondaryCta && !onPrimaryCancel &&(
            <PopupSecondaryLink id="anrCancel" onClick={secondaryCta}>
              {secondaryCtaLabel}
            </PopupSecondaryLink>
          )}
        </ButtonContainer>
      }
      afterClose = {()=>{setCheckedBal(false)}}
    >
      <ContentContainer>
        <PopupHeading>{title}</PopupHeading>
        {children}
        {onPrimaryCancel && availableBalance &&(
            <div className="hidden-balance">
            <div className="bg-hidden-balance">
              <DisplayFlex>
                  <CustomCheckbox id="chkEntireBalance" data-test='checkbox-entireBalance' onChange={ e => {enbleOKButton(e)}} checked={checkedBal}/>
                  <p className="balance-checklabel">Entire balance of account</p>
              </DisplayFlex>
              <label>{availableBalance}</label>
            </div>
          </div>
          )}
      </ContentContainer>
      
    </StyledErrorPopup>
  );
}

ErrorPopup.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  show: PropTypes.bool.isRequired,
  closable: PropTypes.bool,
  className: PropTypes.string,
  primaryCta: PropTypes.func,
  primaryCtaLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  secondaryCta: PropTypes.func,
  secondaryCtaLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  availableBalance: PropTypes.string,
};
